export const MY_TRIALS_TYPE = 'My trials';
export const MY_FILTERS_TYPE = 'My filters';
export const MY_SITE_HEALTH_TYPE = 'My sites';
